module.exports = __webpack_public_path__ + "assets/img/4d3f3a6ec505a64a76c4d400f529c950.svg";